/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps, react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import eventImage from "../../../../assets/images/eventImages/eventImage.jpg";

import { useNavigate, useParams } from "react-router-dom";
import { useCreateEventContext } from "../../../../context/CreateEventContext";
import ModalLoadingState from "../../../PopUpModal/ModalLoadingState";
import {
  convertTo12HourFormat,
  formatDateIntoString,
} from "../../../../utils/dateAndTime";
import SocialMediaHandles from "../../../SocialMediaHandles/SocialMediaHandles";
import flag_icon from "../../../../assets/images/flag.svg"

const EventDetails = ({ onWithdraw }) => {
                                           const { t } = useTranslation();
                                           const navigate = useNavigate();
                                           const eventId = useParams();
                                           // const eventId = selectedEvent;
                                           const [
                                             isLoading,
                                             setIsLoading,
                                           ] = useState(true);
                                           const {
                                             getEventData,
                                             eventData,
                                           } = useCreateEventContext();

                                           useEffect(() => {
                                             if (eventId.id) {
                                               const fetchEvent = async () => {
                                                 setIsLoading(true);
                                                 try {
                                                   const event = await getEventData(
                                                     eventId.id,
                                                   );
                                                 } catch (error) {
                                                   console.log(
                                                     "error fetching event",
                                                     error,
                                                   );
                                                 } finally {
                                                   setIsLoading(false);
                                                 }
                                               };
                                               fetchEvent();
                                             }
                                           }, [eventId.id]); // eslint-disable-line react-hooks/exhaustive-deps

                                           const handleBack = () => {
                                             console.log("back");
                                             navigate("/");
                                           };
                                           const handleApplyToEvent = () => {
                                             console.log("applyToEvent");
                                             navigate(
                                               "/mps/event-registration/" +
                                                 eventId.id,
                                             );
                                           };

                                           return (
                                             <>
                                               {isLoading ? (
                                                 <ModalLoadingState />
                                               ) : (
                                                 <div className="w-full p-6">
                                                   <p className="mb-7 pl-1 pr-1 sm:pr-8 sm:pl-8 text-xl font-medium text-grey-900">
                                                     {t('eventDetails.editDetailsTitle')}
                                                   </p>
                                                   <div className="flex flex-col items-center justify-center w-full rounded-2xl">
                                                     <div className="flex items-center justify-between w-full pl-1 pr-1 sm:pr-8 sm:pl-8 ">
                                                       {/* Event Details */}

                                                       <div className="mx-auto w-full">
                                                         <div className="flex flex-col gap-8 lg:flex-row md:gap-10 lg:gap-28">
                                                           {/* Left Section */}

                                                           <div className="flex-1 space-y-8 xs:w-14">
                                                             {/* Event Date and Time */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="text-2xl">
                                                                 <ion-icon
                                                                   name="calendar-outline"
                                                                   className="text-xl font-medium"
                                                                 ></ion-icon>
                                                               </div>
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {formatDateIntoString(
                                                                     eventData?.startDate,
                                                                   )}
                                                                 </span>
                                                                 {eventData?.startTime &&
                                                                   eventData?.endTime && (
                                                                     <p className="text-sm font-normal text-grey-700">
                                                                       {convertTo12HourFormat(
                                                                         eventData?.startTime,
                                                                       )}{" "}
                                                                       -
                                                                       {convertTo12HourFormat(
                                                                         eventData?.endTime,
                                                                       )}
                                                                     </p>
                                                                   )}
                                                               </div>
                                                             </div>
                                                             {/* Event location and address */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="text-2xl">
                                                                 <ion-icon
                                                                   name="location-outline"
                                                                   className="text-xl font-medium"
                                                                 ></ion-icon>
                                                               </div>

                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {
                                                                     eventData.location
                                                                   }
                                                                 </span>
                                                                 <p className="text-sm font-normal text-grey-700">
                                                                   {
                                                                     eventData.location
                                                                   }
                                                                 </p>
                                                               </div>
                                                             </div>
                                                             {/* Registration Deadline */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="text-2xl">
                                                                 <ion-icon
                                                                   name="calendar-outline"
                                                                   className="text-xl font-medium"
                                                                 ></ion-icon>
                                                               </div>
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('eventDetails.registrationDeadlineLabel')}
                                                                 </span>
                                                                 <p className="text-sm font-normal text-grey-700">
                                                                   {formatDateIntoString(
                                                                     eventData.deadlineDate,
                                                                   )}
                                                                 </p>
                                                               </div>
                                                             </div>
                                                             {/* MarketPlace Seller capacity */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="text-2xl">
                                                                 <ion-icon
                                                                   name="person-outline"
                                                                   className="text-xl font-medium"
                                                                 ></ion-icon>
                                                               </div>
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('mpsDetails.marketplaceSellerCapacity')}
                                                                 </span>
                                                                 <p className="text-sm font-normal text-grey-700">
                                                                   {
                                                                     eventData.sellerCapacity
                                                                   }
                                                                 </p>
                                                               </div>
                                                             </div>
                                                             {/* Website */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('eventDetails.websiteLabel')}
                                                                 </span>
                                                                 <p className="text-sm font-normal text-grey-700">
                                                                   {eventData.eoEventWebsiteURL ? (
                                                                     <a
                                                                       href={eventData.eoEventWebsiteURL.startsWith('http') ? eventData.eoEventWebsiteURL : `https://${eventData.eoEventWebsiteURL}`}
                                                                       target="_blank"
                                                                       rel="noopener noreferrer"
                                                                       className="text-primary-600 hover:text-primary-700 underline underline-offset-2"
                                                                     >
                                                                       {eventData.eoEventWebsiteURL}
                                                                     </a>
                                                                   ) : '—'}
                                                                 </p>
                                                               </div>
                                                             </div>
                                                             {/* Social Media */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('eventDetails.socialMediaLabel')}
                                                                 </span>
                                                                 <div className="text-sm font-normal text-grey-700">
                                                                   <SocialMediaHandles
                                                                     handles={
                                                                       eventData.socialMediaHandles
                                                                     }
                                                                   />
                                                                 </div>
                                                               </div>
                                                             </div>
                                                           </div>
                                                           {/* Right Section */}
                                                           <div className="flex-auto space-y-8 lg:w-64 md:w-full">
                                                             <div className="flex justify-start gap-16">
                                                               {/* Assigned booth */}
                                                               <div className="">
                                                                 <p className="text-md text-grey-900 font-medium inline-flex">
                                                                   <span>
                                                                     <img
                                                                       src={
                                                                         flag_icon
                                                                       }
                                                                       className="h-[19.5px] w-[16.5px] mx-2"
                                                                       alt=""
                                                                     />
                                                                   </span>
                                                                   {t('mpsDetails.assignedBooth')}
                                                                 </p>
                                                                 <p className="pt-1 text-sm text-grey-700 font-normal">
                                                                   {eventData?.assignedBooth ||
                                                                     "-"}
                                                                 </p>
                                                               </div>

                                                               {/* Registration Fee */}
                                                               <div className="flex gap-2 font-medium">
                                                                 <div className="text-2xl">
                                                                   <ion-icon
                                                                     name="card-outline"
                                                                     className="text-xl font-medium"
                                                                   ></ion-icon>
                                                                 </div>
                                                                 <div className="space-y-2 mt-[3px]">
                                                                   <span className="font-medium text-md text-grey-900 ">
                                                                     {t('eventDetails.registrationFeeLabel')}
                                                                   </span>
                                                                   <p className="text-sm font-normal text-grey-700">
                                                                     {
                                                                       eventData.registrationFee
                                                                     }
                                                                   </p>
                                                                 </div>
                                                               </div>
                                                             </div>

                                                             {/* About */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('eventDetails.aboutLabel')}
                                                                 </span>
                                                                 <p className="text-sm font-normal text-grey-700">
                                                                   {
                                                                     eventData.description
                                                                   }
                                                                 </p>
                                                               </div>
                                                             </div>
                                                             {/* Required documents */}
                                                             <div className="flex gap-2 font-medium">
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('eventDetails.requiredDocumentation')}
                                                                 </span>
                                                                 <div className="text-sm font-normal text-grey-700">
                                                                   <ul className="pl-5 list-solid-dot">
                                                                     {eventData.documents.map(
                                                                       (
                                                                         doc,
                                                                         index,
                                                                       ) => (
                                                                         <li
                                                                           key={
                                                                             index
                                                                           }
                                                                         >
                                                                           {
                                                                             doc.documentName
                                                                           }
                                                                         </li>
                                                                       ),
                                                                     )}
                                                                   </ul>
                                                                 </div>
                                                               </div>
                                                             </div>
                                                             {/* Permitted Marketplace Seller Types */}
                                                             <div className="flex gap-2 font-medium">
                                                               {/* <ion-icon
                      name="calendar-outline"
                      className="text-xl font-medium"
                    ></ion-icon> */}
                                                               <div className="space-y-1">
                                                                 <span className="font-medium text-md text-grey-900">
                                                                   {t('mpsDetails.permittedSellerTypes')}
                                                                 </span>
                                                                 <div className="text-sm font-normal text-grey-900">
                                                                   <div className="grid grid-cols-1 gap-2 text-xs md:grid-cols-2 lg:grid-cols-3 text-grey-900">
                                                                     {eventData.sellerTypes.map(
                                                                       (
                                                                         type,
                                                                       ) => (
                                                                         <div
                                                                           key={
                                                                             type
                                                                           }
                                                                           className="flex items-center space-x-10"
                                                                         >
                                                                           <label className="text-xs text-grey-900">
                                                                             {
                                                                               type
                                                                             }
                                                                           </label>
                                                                         </div>
                                                                       ),
                                                                     )}
                                                                   </div>
                                                                 </div>
                                                               </div>
                                                             </div>
                                                           </div>
                                                         </div>
                                                       </div>
                                                     </div>
                                                     <div className="flex flex-col sm:flex-row items-center justify-end gap-4 pt-4 w-full">
                                                       {eventData?.applicationStatus && (
                                                         <button
                                                           className="w-full sm:w-auto justify-center text-grey-900 rounded-md underline px-3 py-2 mt-4 text-xs font-semibold transition duration-150 ease-in-out"
                                                           onClick={onWithdraw}
                                                         >
                                                           {t('mpsDetails.withdrawApplication')}
                                                         </button>
                                                       )}
                                                     </div>
                                                   </div>
                                                 </div>
                                               )}
                                             </>
                                           );
                                         };

export default EventDetails;
